import { Component } from '@angular/core'

@Component({
    selector: 'app-free-selection-panel',
    templateUrl: './selection-panel.component.html',
    styleUrls: ['./selection-panel.component.scss'],
})
export class SelectionPanelComponent {}
